/**
 * @generated SignedSource<<3358294724c0c7cc7cb1b4008ad79c0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type opinionArticleContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent" | "globalCheckerContent" | "headerOpinionArticle" | "hooksContentHelperContent" | "reduceWhitespaceByAvailableSpaceArticle">;
  readonly " $fragmentType": "opinionArticleContent";
};
export type opinionArticleContent$key = {
  readonly " $data"?: opinionArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"opinionArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "opinionArticleContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerOpinionArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksContentHelperContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "reduceWhitespaceByAvailableSpaceArticle"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "8907a545d2ec6b1a2971ca129dc3b9ab";

export default node;
